var map = {
	"./GWC.png": "68ce",
	"./Grace-Hopper-Conference-2019.jpg": "3a00",
	"./Grid-Strat_Demo.jpg": "9726",
	"./HackUNO.jpg": "5173",
	"./Morgan-TOPS.jpg": "4ed4",
	"./Morgan.jpg": "f11f",
	"./RecipeFinder.jpg": "1437",
	"./Resume.docx": "f9c6",
	"./Resume.pdf": "6cb9",
	"./Sunnyvale.jpg": "4b31",
	"./Teaching-Hello-Code.jpg": "8663",
	"./bank-of-america.png": "48cb",
	"./fnbo.png": "dfc0",
	"./mutual-of-omaha.png": "a0f4",
	"./spreetail.png": "b4c8",
	"./twitch-logo.png": "47bc",
	"./union-pacific.png": "a165",
	"./uno-icon.png": "692f"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "1771";